<template>
  <v-container id="citygroup-edit" fluid tag="section">
    <v-card>
      <v-form id="form" class="px-5 pt-5">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="citygroup.name" :label="$i18n.t('Name')" />
          </v-col>
          <v-col cols="12" md="3">
            <z-country-select
              v-model="citygroup.country"
              @input="citygroup.cities = []"
            />
          </v-col>
          <v-col cols="12" md="3">
            <z-client-select v-model="citygroup.client_id" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <h3>{{ $i18n.t("Cities") }}</h3>
          </v-col>
          <v-col cols="12" md="12">
            <z-city-select
              v-model="citygroup.cities"
              multiple
              :country="citygroup.country"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-right mb-5">
            <v-btn
              color="success"
              class="mr-0"
              @click="save()"
              :loading="loading"
            >
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  citygroup = { cities: [] };
  id = null;

  get loading() {
    return common.loading;
  }

  validateSave() {
    if (!this.citygroup.name) {
      common.setError("Please enter Name");
      return false;
    }

    if (!this.citygroup.country) {
      common.setError("Please select Country");
      return false;
    }

    if (!this.citygroup.cities) {
      common.setError("Please select cities");
      return false;
    }
    return true;
  }

  async save() {
    try {
      if (!this.validateSave()) return;
      common.setLoading(true);
      const response = await doPost("/api/citygroups/save", this.citygroup);
      if (!this.id) this.$router.push("/settings/citygroup/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/citygroups/" + id + "/detail");
      if (!response.cities) response.cities = [];
      this.citygroup = response;
      this.id = this.citygroup._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
